import Component from '../../js/core/Component'
import EventBus from '../core/EventBus'

export default class PriceController extends Component {
    constructor(element) {
        super(element);

        this.defaultPrice = (this.element.dataset.price) ? parseInt(this.element.dataset.price) : 0
        this.price = this.defaultPrice

        this.inputID = (this.element.dataset.input) ? this.element.dataset.input : 0
        this.content = this.element.innerHTML
    }

    prepare() {
        EventBus.on('numberInput:change', this.handleChange)
    }

    destroy() {
        EventBus.off('numberInput:change', this.handleChange)
    }

    handleChange = input => {
        event.preventDefault();

        if (input.id != this.inputID) {
            return
        }

        this.change(input.value)
    }

    change(value) {
        const currentPrice = this.defaultPrice * value

        this.content = this.content.replace(this.price, currentPrice)
        this.price = currentPrice
        this.element.innerHTML = this.content
    }
}
